// import * as React from 'react';

// // @mui material components
// import Grid from "@mui/material/Grid";
// import {isEmpty} from "../../../components/Utils/common";

// import MDInput from "../../../components/MDInput";
// import PropTypes from "prop-types";
// import NewUser from "../../users/newUser";
// import { FormControl, InputLabel, Select } from "@mui/material";
// import MenuItem from "@mui/material/MenuItem";
// import { useEffect, useMemo, useState } from "react";
// import { useFormContext } from "react-hook-form";
// import { Controller } from 'react-hook-form';


// function MerchantOfficeDetails({merchant, editmode, setMerchant, type}) {
//   const [referenceCompany, setReferenceCompany] = useState("");
//   const [masterType, setMasterType] = useState("");
//   const [merchantCode, setMerchantCode] = useState("");
//   const { register, formState: { errors }, requiredInfo, control } = useFormContext();

//   useEffect(() => {
//     if(merchant?.merchant?.referenceId) {
//       setReferenceCompany(merchant?.merchant?.referenceId);
//       setMasterType(merchant?.merchant?.microAtmStatus);
//       // setMerchantCode(merchant?.merchant?.merchantCategoryCode.merchantCode);
//     }
//   }, [merchant]);

//   // console.log("ref: ", merchant?.merchant?.referenceId);
//   return (
//       <Grid mt={3} mb={3} padding={2}>
//         <Grid container spacing={2} justifyContent="center">
//         {type === "update" || (editmode && type === "new") ? null : (
//   <Grid item xs={3}>
//     <MDInput
//       type="text"
//       label="Merchant Id"
//       name="mid"
//       error={errors?.mid}
//       helperText={errors.mid ? errors.mid.message : ''}
//    {...register("mid", { defaultValue: "000000" })}
//       fullWidth
//       disabled={type === "update"}
//     />
//   </Grid>
// )}

//           <Grid item xs={3}>
//             <MDInput type="text" label="Registered Business Name" name="companyName"
//                      error={errors.companyName}
//                      helperText={errors.companyName ? errors.companyName.message : ''}
//                      disabled={!editmode}
//                      fullWidth
//                      {...register("companyName")}
//             />
//           </Grid>
        
//           <Grid item xs={3}>
//             <MDInput type="text" label="Registered Business Address" name="address"
//                      {...register("address")}
//                      error={errors.address}
//                      helperText={errors.address ? errors.address.message : ''}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="Actual Business Address" name="addressRes"
//                      {...register("addressRes")}
//                      error={errors.addressRes}
//                      helperText={errors.addressRes ? errors.addressRes.message : ''}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="Postal Code" name="postalCode"
//                      {...register("postalCode")}
//                      error={errors.postalCode}
//                      helperText={errors.postalCode ? errors.postalCode.message : ''}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="MCC" name="mccCode"
//                      {...register("mccCode")}
//                      error={errors.mccCode}
//                      helperText={errors.mccCode ? errors.mccCode.message : ''}
//                      fullWidth  disabled={!editmode} />

            
//           </Grid>
//             <Grid item xs={3}>
//             <MDInput type="text" label="Mobile Number" name="mobileNo"
//                      {...register("mobileNo")}
//                      error={errors.mobileNo}
//                      helperText={errors.mobileNo ? errors.mobileNo.message : ''}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="Email" name="emailId"
//                      {...register("emailId")}
//                      error={errors.emailId}
//                      helperText={errors.emailId ? errors.emailId.message : ''}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
      
//           <Grid item xs={3}>
//             <FormControl fullWidth style={{height: '100%'}}>
//               <InputLabel id="demo-simple-select-label">Reference Company Name</InputLabel>
//               <Controller
//                 name="referenceId"
//                 control={control} // make sure to get "control" from useForm()
//                 defaultValue=""
//                 render={({ field }) => (
//                   <Select
//                     labelId="demo-simple-select-label"
//                     id="demo-simple-select"
//                     label="Reference Company Name"
//                     fullWidth
//                     {...field}
//                     // error={errors.referenceId}
//                     // helperText={errors.referenceId ? errors.referenceId.message : ''}
//                     style={{height: '100%'}}
//                     disabled={!editmode}
//                   >
//                     <MenuItem value=""> -Select Reference Company- </MenuItem>
//                     {requiredInfo?.referenceCompany && requiredInfo.referenceCompany.map((item, key) => (
//                       <MenuItem key={key} value={item?.referenceId}>{item?.referenceCompanyName}</MenuItem>
//                     ))}
//                   </Select>
//                 )}
//               />
//             </FormControl>
//           </Grid>
        
//           <Grid item xs={3}>
         
//           </Grid>
//           <Grid item xs={3}>
           
//           </Grid>
//         </Grid>
//       </Grid>
//   );
// }

// MerchantOfficeDetails.defaultProps = {
//   merchant: false,
//   editmode: false,
//   setMerchant: false,
//   type: 'update',
//   errors: {},
//   register: false
// }

// MerchantOfficeDetails.propTypes = {
//   merchant: PropTypes.any,
//   editmode: PropTypes.bool,
//   setMerchant: PropTypes.func,
//   type: PropTypes.string,
//   errors: PropTypes.object,
//   register: PropTypes.any
// }

// export default MerchantOfficeDetails;



import * as React from "react";

// @mui material components
import Grid from "@mui/material/Grid";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

const numericOnly = (e) => {
  if (!/[0-9]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
    e.preventDefault();
  }
};

function MerchantOfficeDetails({ merchant, editmode, setMerchant, type }) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid mt={1} mb={1} padding={1}>
      <Grid container spacing={1.5}>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="REC Identifier" inputProps={{ maxLength: 1 }}
            {...register("recIdentifier")} error={!!errors.recIdentifier}
            helperText={errors.recIdentifier?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Institution Number" inputProps={{ maxLength: 8 }}
            onKeyDown={numericOnly} {...register("institutionNumber")} error={!!errors.institutionNumber}
            helperText={errors.institutionNumber?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Client Number" inputProps={{ maxLength: 8 }}
            onKeyDown={numericOnly} {...register("clientNumber")} error={!!errors.clientNumber}
            helperText={errors.clientNumber?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Registration Number" inputProps={{ maxLength: 20 }}
            onKeyDown={numericOnly} {...register("registrationNumber")} error={!!errors.registrationNumber}
            helperText={errors.registrationNumber?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Company Name" inputProps={{ maxLength: 60 }}
            {...register("companyName")} error={!!errors.companyName}
            helperText={errors.companyName?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Trade Name" inputProps={{ maxLength: 40 }}
            {...register("tradeName")} error={!!errors.tradeName}
            helperText={errors.tradeName?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Business Class (MCC)" inputProps={{ maxLength: 4 }}
            onKeyDown={numericOnly} {...register("businessClass")} error={!!errors.businessClass}
            helperText={errors.businessClass?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Condition Set" inputProps={{ maxLength: 3 }}
            onKeyDown={numericOnly} {...register("conditionSet")} error={!!errors.conditionSet}
            helperText={errors.conditionSet?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Product" inputProps={{ maxLength: 3 }}
            onKeyDown={numericOnly} {...register("product")} error={!!errors.product}
            helperText={errors.product?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Client Branch" inputProps={{ maxLength: 3 }}
            onKeyDown={numericOnly} {...register("clientBranch")} error={!!errors.clientBranch}
            helperText={errors.clientBranch?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="MID" inputProps={{ maxLength: 15 }}
            onKeyDown={numericOnly} {...register("mid")} error={!!errors.mid}
            helperText={errors.mid?.message ?? ""} disabled={type === "update" || !editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Group MID" inputProps={{ maxLength: 15 }}
            onKeyDown={numericOnly} {...register("groupMid")} error={!!errors.groupMid}
            helperText={errors.groupMid?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Address Line 1" inputProps={{ maxLength: 40 }}
            {...register("addressLine1")} error={!!errors.addressLine1}
            helperText={errors.addressLine1?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Address Line 2" inputProps={{ maxLength: 35 }}
            {...register("addressLine2")} error={!!errors.addressLine2}
            helperText={errors.addressLine2?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Address Line 3" inputProps={{ maxLength: 35 }}
            {...register("addressLine3")} error={!!errors.addressLine3}
            helperText={errors.addressLine3?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="City" inputProps={{ maxLength: 35 }}
            {...register("city")} error={!!errors.city}
            helperText={errors.city?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Post Code" inputProps={{ maxLength: 10 }}
            onKeyDown={numericOnly} {...register("postCode")} error={!!errors.postCode}
            helperText={errors.postCode?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Contact Name" inputProps={{ maxLength: 35 }}
            {...register("contactName")} error={!!errors.contactName}
            helperText={errors.contactName?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Mobile Number" inputProps={{ maxLength: 13 }}
            onKeyDown={numericOnly} {...register("mobileNo")} error={!!errors.mobileNo}
            helperText={errors.mobileNo?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" label="Email" type="email" inputProps={{ maxLength: 30 }}
            {...register("emailId")} error={!!errors.emailId}
            helperText={errors.emailId?.message ?? ""} disabled={!editmode} fullWidth />
        </Grid>

      </Grid>
    </Grid>
  );
}

MerchantOfficeDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: "update",
};

MerchantOfficeDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string,
};

export default MerchantOfficeDetails;
